module.exports = __webpack_public_path__ + "img/1445503700.d79fb6c3.jpg";